export default __webpack_public_path__ + "static/media/flag-ro.96bb1e5b.svg";